import { query } from "../../../../erd-editor-schema/dist/query/index.js";
import { isSerialType, toReferenceDataType } from "../../relationship/referenceType.js";
//#region src/engine/modules/table-column/utils/dataType.ts
function toSyncSteps(relationships) {
	const steps = /* @__PURE__ */ new Map();
	const add = (from, step) => {
		const list = steps.get(from);
		if (list) list.push(step);
		else steps.set(from, [step]);
	};
	for (const { start, end } of relationships) {
		const startIds = [...start.columnIds];
		const endIds = [...end.columnIds];
		const seen = /* @__PURE__ */ new Set();
		startIds.forEach((from, index) => {
			if (seen.has(from)) return;
			seen.add(from);
			const id = endIds[index];
			if (id !== void 0) add(from, {
				id,
				tableId: end.tableId,
				toForeignKey: true
			});
		});
		endIds.forEach((from, index) => {
			if (seen.has(from)) return;
			seen.add(from);
			const id = startIds[index];
			if (id !== void 0) add(from, {
				id,
				tableId: start.tableId,
				toForeignKey: false
			});
		});
	}
	return steps;
}
function getDataTypeSyncColumns(stack, state, payloads = [], relationships = query(state.collections).collection("relationshipEntities").selectByIds(state.doc.relationshipIds), settledIds = /* @__PURE__ */ new Set()) {
	const { collections, settings: { database } } = state;
	const columns = query(collections).collection("tableColumnEntities");
	const steps = toSyncSteps(relationships);
	const listed = new Set(payloads.map(({ id }) => id));
	for (let target = stack.pop(); target; target = stack.pop()) {
		const { id: targetId, value } = target;
		if (listed.has(targetId)) continue;
		payloads.push(target);
		listed.add(targetId);
		const foreignKeyValue = toReferenceDataType(value, database);
		for (const { id, tableId, toForeignKey } of steps.get(targetId) ?? []) {
			if (settledIds.has(id)) continue;
			if (toForeignKey) {
				stack.push({
					id,
					tableId,
					value: foreignKeyValue
				});
				continue;
			}
			const column = columns.selectById(id);
			if (column && isSerialType(column.dataType)) continue;
			stack.push({
				id,
				tableId,
				value
			});
		}
	}
	return payloads;
}
//#endregion
export { getDataTypeSyncColumns };
